<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>assignment_ind</mat-icon>
        <div>Recepção</div>
      </div>

    </mat-toolbar>
  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-tab-group style='width: 540px; margin: auto; ' (selectedTabChange)="tabClick($event)">

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>search</mat-icon>
        <div>Consulta</div>
      </ng-template>

      <mat-card>

        <form [formGroup]="searchForm">

          <div style="display:flex; flex-direction: row; justify-content: space-between;">

            <div style="height: 60px;">

              <mat-form-field class="cpf-width"  appearance="outline">
                <mat-label>Documento</mat-label>
                <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="searchForm.controls.cpf"
                  autocomplete="off">

              </mat-form-field>

              <button mat-raised-button (click)='getMemberByCPF()' [disabled]="searchForm.invalid" class="button">
                <mat-icon>search</mat-icon>
              </button>

            </div>

            <div style="height: 40px; padding-top: 5px;">

              <button mat-raised-button (click)='createNewMember()' class="button" style="margin-top:5px;">
                <mat-icon>add_circle_outline</mat-icon>
              </button>

            </div>

          </div>

        </form>
      </mat-card>

      <mat-card *ngIf="memberExist == 2">
        <p>Não está cadastrado</p>
      </mat-card>

      <mat-card *ngIf="memberExist == 1">

        <!-- TABLE -->
        <mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.name }}
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row (click)='selectedMember(row)' *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-card>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>list</mat-icon>
        <div>Cadastrados</div>
      </ng-template>

      <div flex justify-content='flex-start' fxLayoutAlign="start">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
      </div>

      <!-- TABLE -->
      <mat-table [dataSource]="dataSourceAllMembers" style="margin:0px;" *ngIf="!spinner">

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div style="display: flex; flex-direction: column;">
              <div> {{ element.name }} </div>
              <div><i> {{ element.subCategory.name }} </i></div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cpf">
          <mat-header-cell *matHeaderCellDef> CPF </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div> {{ element.cpf }} </div>
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="displayedColumnsAllMembers"></mat-header-row>

        <!-- Row -->
        <mat-row (click)='selectedMember(row)' *matRowDef="let row; columns: displayedColumnsAllMembers;"></mat-row>

      </mat-table>
      <!-- END TABLE -->

    </mat-tab>

  </mat-tab-group>

</div>